/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    EAFSGAreaDTO,
    EAFSGAreaDTOFromJSON,
    EAFSGAreaDTOToJSON,
    EAFSGAreaDTOPagedResponse,
    EAFSGAreaDTOPagedResponseFromJSON,
    EAFSGAreaDTOPagedResponseToJSON,
    EAFSGAreaUpdateDTO,
    EAFSGAreaUpdateDTOFromJSON,
    EAFSGAreaUpdateDTOToJSON,
} from '../models';

export interface ApiEAFSGAreaAddEAFSGAreaPostRequest {
    eAFSGAreaUpdateDTO?: EAFSGAreaUpdateDTO;
}

export interface ApiEAFSGAreaDeleteEAFSGAreaIdDeleteRequest {
    id: string;
}

export interface ApiEAFSGAreaGetAllEAFSGAreasGetRequest {
    namePattern?: string;
    page?: number;
    pageSize?: number;
}

export interface ApiEAFSGAreaGetEAFSGAreaByIdIdGetRequest {
    id: string;
}

export interface ApiEAFSGAreaUpdateEAFSGAreaIdPutRequest {
    id: string;
    eAFSGAreaUpdateDTO?: EAFSGAreaUpdateDTO;
}

/**
 * 
 */
export class EAFSGAreaApi extends runtime.BaseAPI {

    /**
     */
    async apiEAFSGAreaAddEAFSGAreaPostRaw(requestParameters: ApiEAFSGAreaAddEAFSGAreaPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<EAFSGAreaDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/EAFSGArea/AddEAFSGArea`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EAFSGAreaUpdateDTOToJSON(requestParameters.eAFSGAreaUpdateDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EAFSGAreaDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiEAFSGAreaAddEAFSGAreaPost(requestParameters: ApiEAFSGAreaAddEAFSGAreaPostRequest = {}, initOverrides?: RequestInit): Promise<EAFSGAreaDTO> {
        const response = await this.apiEAFSGAreaAddEAFSGAreaPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEAFSGAreaDeleteEAFSGAreaIdDeleteRaw(requestParameters: ApiEAFSGAreaDeleteEAFSGAreaIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiEAFSGAreaDeleteEAFSGAreaIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/EAFSGArea/DeleteEAFSGArea/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiEAFSGAreaDeleteEAFSGAreaIdDelete(requestParameters: ApiEAFSGAreaDeleteEAFSGAreaIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiEAFSGAreaDeleteEAFSGAreaIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiEAFSGAreaGetAllEAFSGAreasGetRaw(requestParameters: ApiEAFSGAreaGetAllEAFSGAreasGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<EAFSGAreaDTOPagedResponse>> {
        const queryParameters: any = {};

        if (requestParameters.namePattern !== undefined) {
            queryParameters['NamePattern'] = requestParameters.namePattern;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['Page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['PageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/EAFSGArea/GetAllEAFSGAreas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EAFSGAreaDTOPagedResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiEAFSGAreaGetAllEAFSGAreasGet(requestParameters: ApiEAFSGAreaGetAllEAFSGAreasGetRequest = {}, initOverrides?: RequestInit): Promise<EAFSGAreaDTOPagedResponse> {
        const response = await this.apiEAFSGAreaGetAllEAFSGAreasGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEAFSGAreaGetEAFSGAreaByIdIdGetRaw(requestParameters: ApiEAFSGAreaGetEAFSGAreaByIdIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<EAFSGAreaDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiEAFSGAreaGetEAFSGAreaByIdIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/EAFSGArea/GetEAFSGAreaById/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EAFSGAreaDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiEAFSGAreaGetEAFSGAreaByIdIdGet(requestParameters: ApiEAFSGAreaGetEAFSGAreaByIdIdGetRequest, initOverrides?: RequestInit): Promise<EAFSGAreaDTO> {
        const response = await this.apiEAFSGAreaGetEAFSGAreaByIdIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEAFSGAreaUpdateEAFSGAreaIdPutRaw(requestParameters: ApiEAFSGAreaUpdateEAFSGAreaIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<EAFSGAreaDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiEAFSGAreaUpdateEAFSGAreaIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/EAFSGArea/UpdateEAFSGArea/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EAFSGAreaUpdateDTOToJSON(requestParameters.eAFSGAreaUpdateDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EAFSGAreaDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiEAFSGAreaUpdateEAFSGAreaIdPut(requestParameters: ApiEAFSGAreaUpdateEAFSGAreaIdPutRequest, initOverrides?: RequestInit): Promise<EAFSGAreaDTO> {
        const response = await this.apiEAFSGAreaUpdateEAFSGAreaIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
